"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4044,65622,21572],{

/***/ 41327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ processCourse; }
/* harmony export */ });
/* unused harmony export getCourseAuthors */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _models_Course__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56046);
/* harmony import */ var _user__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31079);




var getCourseAuthors = function(course) {
    var ref, ref1;
    if (course === null || course === void 0 ? void 0 : (ref = course.authors) === null || ref === void 0 ? void 0 : ref.length) return course === null || course === void 0 ? void 0 : (ref1 = course.authors) === null || ref1 === void 0 ? void 0 : ref1.map(function(author) {
        return (0,_user__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(author, false);
    });
    if (course === null || course === void 0 ? void 0 : course.author) return [
        (0,_user__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(course.author, false)
    ];
    return [];
};
var processCourse = function(course) {
    var ref, ref1, ref2, ref3;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, course), {
        authors: getCourseAuthors(course),
        liveAt: course.liveAt || course.startsAt,
        liveAtString: course.liveAt || course.startsAt,
        thumbnail: course.coverPhotoV1 || course.coverPhoto || course.thumbnail || (0,_models_Course__WEBPACK_IMPORTED_MODULE_0__/* .getDefaultThumbnail */ .mI)(course),
        coverPhoto: course.coverPhotoV1 || course.coverPhoto || course.thumbnail || (0,_models_Course__WEBPACK_IMPORTED_MODULE_0__/* .getDefaultThumbnail */ .mI)(course),
        newThumbnail: course.coverPhotoV1,
        language: course.languageDisplay || ((ref = course.multipleLanguageDisplay) === null || ref === void 0 ? void 0 : ref[0]),
        averageRating: course.avgRating,
        conceptTopology: ((ref1 = course.conceptTopology) === null || ref1 === void 0 ? void 0 : ref1.name) || ((ref2 = course.conceptTopology) === null || ref2 === void 0 ? void 0 : ref2.title) || ((ref3 = course.topologies) === null || ref3 === void 0 ? void 0 : ref3[0]) || "",
        isUpcoming: (0,_models_Course__WEBPACK_IMPORTED_MODULE_0__/* .isUpcoming */ .Zz)(course.startsAt),
        isOngoing: (0,_models_Course__WEBPACK_IMPORTED_MODULE_0__/* .isOngoing */ .fr)(course.startsAt, course.endsAt),
        isCompleted: course.isCompleted || (0,_models_Course__WEBPACK_IMPORTED_MODULE_0__/* .isCompleted */ .PN)(course.endsAt),
        nextTrack: course.nextTrack || course.nextSession || course.nextClass || course.nextItem,
        previousTrack: course.previousTrack || course.previousSession || course.previousClass || course.previousItem,
        courseType: course.programmeType,
        forPlus: course.forPlus || course.forSubscription
    });
};


/***/ }),

/***/ 66029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils_updaetQuery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78162);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);








var StyledAvatar = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("img", {
    target: "ecs7e9v0",
    label: "StyledAvatar"
})("border-radius:", function(param) {
    var $circular = param.$circular;
    return $circular ? "50%" : _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_2B */ .t8.Rw;
}, ";width:", function(param) {
    var size = param.size;
    return size;
}, ";height:", function(param) {
    var size = param.size;
    return size;
}, ";object-fit:cover;cursor:pointer;user-drag:none;user-select:none;");
var Avatar = function(props) {
    var src = props.src, className = props.className, circular = props.circular, size = props.size, alt = props.alt, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "src",
        "className",
        "circular",
        "size",
        "alt"
    ]);
    var webp = (0,_utils_updaetQuery__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(src, "fm", "webp");
    var imageType = (src === null || src === void 0 ? void 0 : src.includes("png")) ? "png" : "jpg";
    var isBase64 = src === null || src === void 0 ? void 0 : src.startsWith("data:image");
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)("picture", {
        children: [
            !isBase64 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .Fragment */ .HY, {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("source", {
                        srcSet: webp,
                        type: "image/webp"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("source", {
                        srcSet: src,
                        type: "image/".concat(imageType)
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(StyledAvatar, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
                $circular: circular,
                visibleByDefault: true,
                src: src,
                className: className,
                height: size,
                width: size,
                decoding: "async",
                loading: "eager",
                alt: alt
            }))
        ]
    });
};
Avatar.propTypes = {
    src: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    height: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    width: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    size: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    circular: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string)
};
Avatar.defaultProps = {
    src: "/static/images/filler.png",
    height: "initial",
    width: "initial",
    size: null,
    className: "",
    circular: false,
    alt: "Avatar"
};
/* harmony default export */ __webpack_exports__["Z"] = (Avatar);


/***/ }),

/***/ 13909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95477);




var StyledCircularProgress = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    target: "e1622i1o0",
    label: "StyledCircularProgress"
})("color:", function(param) {
    var $customColor = param.$customColor;
    return $customColor;
}, ";");
var CircularLoader = function(param) {
    var color = param.color, size = param.size, className = param.className;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(StyledCircularProgress, {
        $customColor: color,
        size: size,
        className: className
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CircularLoader);
CircularLoader.propTypes = {
    color: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    size: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)
};
CircularLoader.defaultProps = {
    color: "var(--color-i-green)",
    size: 40,
    className: ""
};


/***/ }),

/***/ 50699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _material_ui_core_LinearProgress__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33681);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _styleConstants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);

/* eslint-disable jsx-a11y/mouse-events-have-key-events */ 



var StyledProgress = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_material_ui_core_LinearProgress__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    target: "e14diw8s0",
    label: "StyledProgress"
})("&.MuiLinearProgress-root{background-color:", function(param) {
    var $backgroundColor = param.$backgroundColor;
    return $backgroundColor;
}, ";width:", function(param) {
    var $width = param.$width;
    return $width;
}, ";height:", function(param) {
    var $height = param.$height;
    return $height;
}, ";align-self:center;border-radius:", function(param) {
    var $borderRadius = param.$borderRadius;
    return $borderRadius;
}, ";}&.MuiLinearProgress-root .MuiLinearProgress-bar{border-radius:", function(param) {
    var borderRadius = param.borderRadius;
    return borderRadius;
}, ";background-color:", function(param) {
    var $overlayColor = param.$overlayColor;
    return $overlayColor;
}, ";}");
var LinearProgressBar = function(param) {
    var value = param.value, variant = param.variant, width = param.width, height = param.height, borderRadius = param.borderRadius, backgroundColor = param.backgroundColor, overlayColor = param.overlayColor, className = param.className, onMouseOver = param.onMouseOver, onMouseOut = param.onMouseOut;
    var progress = value > 100 ? 100 : value;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StyledProgress, {
        variant: variant,
        value: progress,
        $width: width,
        $height: height,
        $borderRadius: borderRadius,
        $backgroundColor: backgroundColor,
        $overlayColor: overlayColor,
        className: className,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LinearProgressBar);
LinearProgressBar.propTypes = {
    variant: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    value: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().number),
    width: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    height: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    borderRadius: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    backgroundColor: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    overlayColor: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().string),
    onMouseOver: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func),
    onMouseOut: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().func)
};
LinearProgressBar.defaultProps = {
    variant: "determinate",
    width: "105px",
    height: _styleConstants__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_1B */ .t8.MK,
    borderRadius: _styleConstants__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_5B */ .t8.zj,
    backgroundColor: "var(--color-divider)",
    overlayColor: "var(--color-i-green)",
    className: "",
    onMouseOver: null,
    value: 0,
    onMouseOut: function() {}
};


/***/ }),

/***/ 55161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var _material_ui_core_Menu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21322);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70917);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87312);






var keyFrameOpen = function(height) {
    return /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.keyframes)("0%{max-height:0px;}50%{max-height:", height || "276px", ";padding-bottom:20px;}100%{padding-bottom:0px;}", "keyFrameOpen");
};
var keyFrameClose = function(height) {
    return /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.keyframes)("0%{padding-bottom:20px;max-height:", height || "276px", ";}100%{padding-bottom:0px;max-height:0px;}", "keyFrameClose");
};
var animationOpen = function(height) {
    return /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(keyFrameOpen(height), " 300ms ease-in 0s", "animationOpen");
};
var animationClose = function(height) {
    return /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(keyFrameClose(height), " 300ms ease-out 0s", "animationClose");
};
var StyledMenu = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_material_ui_core_Menu__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    target: "elxihdt0",
    label: "StyledMenu"
})("&.MuiPopover-root .MuiPaper-root{width:", function(param) {
    var width = param.width;
    return width;
}, ";border:", function(param) {
    var $noBorder = param.$noBorder;
    return $noBorder ? "none" : "1px solid var(--color-shadow)";
}, ";border-radius:8px;margin-top:10px;background-color:var(--color-base-1);box-shadow:", (0,_utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(), ";transform:none !important;opacity:1 !important;animation:", function(param) {
    var open = param.open, height = param.height;
    return open ? animationOpen(height) : animationClose(height);
}, ";max-height:", function(param) {
    var height = param.height;
    return height;
}, ";-ms-overflow-style:none;/* Internet Explorer 10+ */\n    scrollbar-width:none;/* Firefox */\n    /* Chrome and IOS Safari */::-webkit-scrollbar{width:0px;background:transparent;}}&.MuiPopover-root .MuiMenu-list{padding-top:", function(param) {
    var $noPadding = param.$noPadding;
    return $noPadding ? "0px" : "8px";
}, ";padding-bottom:", function(param) {
    var $noPadding = param.$noPadding;
    return $noPadding ? "0px" : "8px";
}, ";}");
var Menu = function(param) {
    var children = param.children, anchorEl = param.anchorEl, onClose = param.onClose, position = param.position, width = param.width, height = param.height, noPadding = param.noPadding, noBorder = param.noBorder, anchorOrigin = param.anchorOrigin, transformOrigin = param.transformOrigin, className = param.className, disablePortal = param.disablePortal;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(StyledMenu, {
        className: className,
        anchorEl: anchorEl,
        open: Boolean(anchorEl),
        onClose: onClose,
        elevation: 0,
        getContentAnchorEl: null,
        anchorOrigin: anchorOrigin || {
            vertical: "bottom",
            horizontal: position
        },
        transformOrigin: transformOrigin || {
            vertical: "top",
            horizontal: position
        },
        variant: "menu",
        transitionDuration: 200,
        width: width,
        height: height,
        $noPadding: noPadding,
        $noBorder: noBorder,
        disablePortal: disablePortal,
        children: children
    });
};
Menu.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node.isRequired),
    onClose: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func.isRequired),
    anchorOrigin: prop_types__WEBPACK_IMPORTED_MODULE_5___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_5___default().any)),
    transformOrigin: prop_types__WEBPACK_IMPORTED_MODULE_5___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_5___default().any)),
    position: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf([
        "left",
        "center",
        "right"
    ]),
    width: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    height: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    noPadding: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    noBorder: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    anchorEl: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf([
        null,
        (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node)
    ]),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    disablePortal: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool)
};
Menu.defaultProps = {
    anchorOrigin: null,
    transformOrigin: null,
    position: "left",
    width: "auto",
    height: "276px",
    noPadding: false,
    noBorder: false,
    anchorEl: null,
    className: "",
    disablePortal: false
};
/* harmony default export */ __webpack_exports__["Z"] = (Menu);


/***/ }),

/***/ 5894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _icon_StarFilled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52885);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31309);
/* harmony import */ var _H7_H7__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28197);
/* harmony import */ var _P2_P2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72560);
/* harmony import */ var _styleConstants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2080);








var colorOrange = "var(--color-i-orange-1)";
var colorFontLightGrey = "var(--color-text-secondary)";
var Flex = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "elmncjz0",
    label: "Flex"
})("display:flex;align-items:center;");
var Rating = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_H7_H7__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    target: "elmncjz1",
    label: "Rating"
})("margin-right:", _styleConstants__WEBPACK_IMPORTED_MODULE_5__/* .Spacings.SPACING_3B */ .t8.N, ";margin-left:", _styleConstants__WEBPACK_IMPORTED_MODULE_5__/* .Spacings.SPACING_1B */ .t8.MK, ";");
var Reviews = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_P2_P2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    target: "elmncjz2",
    label: "Reviews"
})("margin-left:3px;margin-right:3px;");
var StarRating = function(param) {
    var rating = param.rating, ratingsCount = param.ratingsCount, reviewsCount = param.reviewsCount, className = param.className;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(Flex, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_icon_StarFilled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                color: colorOrange,
                size: _styleConstants__WEBPACK_IMPORTED_MODULE_5__/* .Spacings.SPACING_3B */ .t8.N
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(Rating, {
                color: colorOrange,
                className: className,
                children: rating
            }),
            ratingsCount ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_P2_P2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                color: colorFontLightGrey,
                children: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_2__/* .pluralize */ ._6)(ratingsCount, "rating")
            }) : null,
            reviewsCount && ratingsCount ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(Reviews, {
                color: colorFontLightGrey,
                children: " \u2022 "
            }) : null,
            reviewsCount ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_P2_P2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                color: colorFontLightGrey,
                children: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_2__/* .pluralize */ ._6)(reviewsCount, "review")
            }) : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StarRating);
StarRating.propTypes = {
    rating: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().number.isRequired),
    ratingsCount: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().number.isRequired),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    reviewsCount: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().number)
};
StarRating.defaultProps = {
    className: "",
    reviewsCount: 0
};


/***/ }),

/***/ 75135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52420);
/* harmony import */ var _base_Thumbnail_Thumbnail__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75591);
/* harmony import */ var _api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85780);
/* harmony import */ var _api_selectors_auth__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(73060);
/* harmony import */ var _models_Batch__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47835);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31309);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2080);
/* harmony import */ var _actions_analytics__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87936);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43135);
/* harmony import */ var _constants_segment__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(17579);
/* harmony import */ var _hooks_useGoalEventProps__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(52405);
/* harmony import */ var aquilla_core_organisms_BatchCard__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(59978);
/* harmony import */ var _selectors_learner__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(11680);
/* harmony import */ var _utils_pushRoute__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(751);
/* harmony import */ var _cont_Batch_utils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(73993);
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(5950);



/* eslint-disable no-param-reassign */ 

















var CourseThumbnail = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_base_Thumbnail_Thumbnail__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    target: "e1grwn200",
    label: "CourseThumbnail"
})("border-top-left-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_2B */ .t8.Rw, ";border-top-right-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_2B */ .t8.Rw, ";", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .mediaQuery.uptoTablet */ .cy.uptoTablet, "{width:100%;height:190px;}");
var BatchCard = function(param) {
    var _orientation = param.orientation, orientation = _orientation === void 0 ? "vertical" : _orientation, _firstAuthorUsername = param.firstAuthorUsername, firstAuthorUsername = _firstAuthorUsername === void 0 ? "" : _firstAuthorUsername, _dataAnalytics = param.dataAnalytics, dataAnalytics = _dataAnalytics === void 0 ? "" : _dataAnalytics, _type = param.type, type = _type === void 0 ? "" : _type, _searchData = param.searchData, searchData = _searchData === void 0 ? {} : _searchData, _onClick = param.onClick, onClick = _onClick === void 0 ? function() {} : _onClick, _updateRecentSearchLog = param.updateRecentSearchLog, updateRecentSearchLog = _updateRecentSearchLog === void 0 ? function() {} : _updateRecentSearchLog, _batch = param.batch, batch = _batch === void 0 ? {} : _batch, _index = param.index, index = _index === void 0 ? 0 : _index;
    var ref, ref1;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var batchGoalUID = (batch === null || batch === void 0 ? void 0 : (ref = batch.goal) === null || ref === void 0 ? void 0 : ref.uid) || "";
    var ref2 = batch || {}, startsAt = ref2.startsAt, endsAt = ref2.endsAt, timeType = ref2.timeType;
    var firstUser = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)((0,_selectors_learner__WEBPACK_IMPORTED_MODULE_13__/* .getUserById */ .GA)(firstAuthorUsername));
    var meUID = (0,_api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_api_selectors_auth__WEBPACK_IMPORTED_MODULE_17__/* .getMeUid */ .Up);
    var languages = batch.languages, name = batch.name;
    var authors = (ref1 = batch.authors) === null || ref1 === void 0 ? void 0 : ref1.map(function(author) {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, author), {
            name: author.name || "".concat(author.firstName, " ").concat(author.lastName)
        });
    });
    // @ts-ignore
    var goalSegmentData = (0,_hooks_useGoalEventProps__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
        batchGoalUID: batchGoalUID
    });
    if (!batch) return null;
    var isPartnerEducator = batch.educatorType === _cont_Batch_utils__WEBPACK_IMPORTED_MODULE_15__/* .EDUCATOR_TYPES.PARTNER */ .MB.PARTNER;
    var handleAnalytics = function() {
        if (onClick) onClick();
        var batchUID = batch.uid || "";
        if (type === "search") {
            var nSearchData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, searchData);
            delete nSearchData.query;
            var position = nSearchData.position ? nSearchData.position : "See all";
            _actions_analytics__WEBPACK_IMPORTED_MODULE_8__/* .segment.track */ .EX.track(_constants_segment__WEBPACK_IMPORTED_MODULE_10__/* .SEARCH_RESULT_CLICKED */ .dW7, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, goalSegmentData, nSearchData), {
                sub_position: index + 1,
                educator_uid: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_6__/* .getCommaSeparatedUIDs */ .$V)(authors),
                educator_username: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_6__/* .getCommaSeparatedUIDs */ .$V)(authors, "username"),
                educator_name: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_6__/* .getCommaSeparatedUIDs */ .$V)(authors, "name"),
                last_primary_source: _constants_segment__WEBPACK_IMPORTED_MODULE_10__/* .SEARCH_RESULT_PAGE */ .jDH,
                last_primary_source_section: "Batches",
                search_section: "Global",
                current_screen: "Batches",
                eventName: _constants_segment__WEBPACK_IMPORTED_MODULE_10__/* .SEARCH_RESULT_CLICKED */ .dW7,
                eventType: "click",
                version: 2,
                objectID: "".concat(searchData.object_type, ":").concat(batchUID),
                userToken: meUID
            }), nSearchData), {
                position: position
            }), _constants_index__WEBPACK_IMPORTED_MODULE_9__/* .evtNameCategoryMap.WITHOUT_CATEGORY */ .xK.WITHOUT_CATEGORY);
            dispatch(// @ts-ignore
            updateRecentSearchLog((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)({}, searchData), {
                entity_id: "".concat(searchData.object_type, ":").concat(batchUID),
                goal_uid: batchGoalUID
            })));
        }
        var route = {
            href: (0,_models_Batch__WEBPACK_IMPORTED_MODULE_5__/* .getLinkPath */ .bc)(isPartnerEducator),
            as: (0,_models_Batch__WEBPACK_IMPORTED_MODULE_5__/* .getLink */ .Rg)(batch, isPartnerEducator)
        };
        (0,_utils_pushRoute__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(route.href, route.as);
    };
    var renderLanguages = function() {
        var languagesToShow = (languages === null || languages === void 0 ? void 0 : languages.length) > 3 ? languages.slice(0, 3) : languages;
        var labelLanguages = (languagesToShow === null || languagesToShow === void 0 ? void 0 : languagesToShow.map(function(param) {
            var label = param.label;
            return label;
        })) || [];
        return labelLanguages.toString();
    };
    var thumbnail = function() {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsx */ .tZ)(CourseThumbnail, {
            imgUrl: batch.thumbnail || batch.coverPhoto,
            orientation: orientation,
            "data-analytics": "".concat(dataAnalytics, "Card")
        });
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__/* .jsx */ .tZ)(aquilla_core_organisms_BatchCard__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        thumbnail: thumbnail,
        batchTiming: timeType === null || timeType === void 0 ? void 0 : timeType.text,
        educatorNames: (0,_util__WEBPACK_IMPORTED_MODULE_16__/* .authorsInfo */ .ZW)(firstUser, authors),
        href: (0,_models_Batch__WEBPACK_IMPORTED_MODULE_5__/* .getLink */ .Rg)(batch, isPartnerEducator),
        langLabel: renderLanguages(),
        onClick: handleAnalytics,
        startsIn: (0,_util__WEBPACK_IMPORTED_MODULE_16__/* .getDateInfo */ .on)(startsAt, endsAt),
        title: name,
        topicColor: "var(--color-text-primary)",
        topicName: (0,_util__WEBPACK_IMPORTED_MODULE_16__/* .getBatchTag */ .vi)(batch),
        variant: "default"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BatchCard);


/***/ }),

/***/ 5950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZW": function() { return /* binding */ authorsInfo; },
/* harmony export */   "on": function() { return /* binding */ getDateInfo; },
/* harmony export */   "vi": function() { return /* binding */ getBatchTag; }
/* harmony export */ });
/* harmony import */ var _constants_empty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59375);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97428);


var oneDay = 24 * 60 * 60 * 1000;
var getBatchTag = function() {
    var batch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var syllabusTag = batch.syllabusTag, allTopicsCovered = batch.allTopicsCovered;
    var tag = allTopicsCovered ? "Full syllabus" : "Partial Syllabus";
    return syllabusTag || tag;
};
var getDateInfo = function(startAt, endAt) {
    if (!startAt) return null;
    var start = new Date(startAt).setHours(0, 0, 0, 0);
    var end = endAt && new Date(endAt).setHours(0, 0, 0, 0);
    var current = new Date().setHours(0, 0, 0, 0);
    var startText = "".concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_1__/* .getDay */ .wf)(startAt), " ").concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_1__/* .getMonthString */ .dV)(startAt), " ").concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_1__/* .getYear */ .So)(startAt));
    var endText = endAt && "".concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_1__/* .getDay */ .wf)(endAt), " ").concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_1__/* .getMonthString */ .dV)(endAt), " ").concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_1__/* .getYear */ .So)(endAt));
    var dateInfo = "";
    if (start >= current) {
        var diff = Math.ceil((start - current) / oneDay);
        if (diff < 1) {
            dateInfo = "Starts today \xb7 ".concat(startText);
        } else if (diff < 2) {
            dateInfo = "Starts tomorrow \xb7 ".concat(startText);
        } else if (diff > 1 && diff < 8) {
            dateInfo = "Starts in ".concat(diff, " days \xb7 ").concat(startText);
        } else {
            dateInfo = "Starts on ".concat(startText);
        }
    } else if (start < current && (!end || current < end)) {
        dateInfo = "Started on ".concat(startText);
    } else {
        dateInfo = "Ended on ".concat(endText);
    }
    return dateInfo;
};
var authorsInfo = function(firstUser, batchAuthors) {
    var firstUserName = firstUser === null || firstUser === void 0 ? void 0 : firstUser.name;
    var authorsNameArr = (batchAuthors === null || batchAuthors === void 0 ? void 0 : batchAuthors.map(function(author) {
        return author.name;
    })) || _constants_empty__WEBPACK_IMPORTED_MODULE_0__/* .emptyList */ .n8;
    if (firstUserName) {
        if (authorsNameArr.length) {
            var index = authorsNameArr.indexOf(firstUserName);
            authorsNameArr.splice(index, 1);
            authorsNameArr.splice(0, 0, firstUserName);
        } else {
            return firstUserName;
        }
    }
    if (authorsNameArr.length) {
        if (authorsNameArr.length < 2) {
            return authorsNameArr[0];
        }
        if (authorsNameArr.length > 1 && authorsNameArr.length < 4) {
            return "".concat(authorsNameArr.slice(0, -1).join(", "), " and ").concat(authorsNameArr.slice(-1));
        }
        return "".concat(authorsNameArr.slice(0, 3).join(", "), " and ").concat(authorsNameArr.length - 3, " more");
    }
    return "";
};


/***/ }),

/***/ 8477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14293);
/* harmony import */ var lodash_isNil__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_isNil__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _base_Menu_Menu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55161);
/* harmony import */ var _base_H6_H6__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10076);
/* harmony import */ var _icon_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21572);
/* harmony import */ var _utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87312);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2080);
/* harmony import */ var _MenuItem__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98811);

/* eslint-disable react/display-name */ /* eslint-disable react/prop-types */ 









var DropDownButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("button", {
    target: "e1v4hctf0",
    label: "DropDownButton"
})("display:flex;justify-content:space-between;min-width:fit-content;align-self:center;align-items:center;line-height:150%;cursor:", function(param) {
    var $isDisabled = param.$isDisabled;
    return $isDisabled ? "not-allowed" : "pointer";
}, ";transition:all 400ms ease-in-out;border-width:1px;border-style:solid;font-weight:600;border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_2B */ .t8.Rw, ";background-color:var(--color-base-1);grid-column:", function(param) {
    var gridColumn = param.gridColumn;
    return gridColumn;
}, ";padding:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_3B */ .t8.N, " ", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_4B */ .t8.BM, ";font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Fonts.SMALL */ .F3.HC, ";color:var(--color-text-primary);box-shadow:", (0,_utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(), ";border-color:", function(param) {
    var showSelectedBorder = param.showSelectedBorder, open = param.open;
    if (showSelectedBorder) return "var(--color-text-primary)";
    if (open) return "var(--color-divider)";
    return "var(--color-shadow)";
}, ";", function(param) {
    var buttonWidth = param.buttonWidth;
    return buttonWidth && "width: ".concat(buttonWidth, ";");
}, ":hover{background-color:var(--color-base-1);border-color:", function(param) {
    var showSelectedBorder = param.showSelectedBorder;
    return showSelectedBorder ? "var(--color-text-primary)" : "var(--color-divider)";
}, ";box-shadow:", (0,_utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    yOffset: _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_2B */ .t8.Rw,
    blur: _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_2B */ .t8.Rw
}), ";}@media (max-width:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .breakpoints.mobile */ .AV.mobile, "){font-size:12px;padding:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_2B */ .t8.Rw, " ", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_3B */ .t8.N, ";white-space:nowrap;grid-column:", function(param) {
    var mwGridColumn = param.mwGridColumn;
    return mwGridColumn || "auto";
}, " !important;}");
var Button = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(param, ref) {
    var open = param.open, onClick = param.onClick, gridColumn = param.gridColumn, mwGridColumn = param.mwGridColumn, children = param.children, showSelectedBorder = param.showSelectedBorder, className = param.className, buttonWidth = param.buttonWidth, $isDisabled = param.$isDisabled;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(DropDownButton, {
        open: open,
        onClick: onClick,
        gridColumn: gridColumn,
        mwGridColumn: mwGridColumn,
        ref: ref,
        showSelectedBorder: showSelectedBorder,
        className: className,
        type: "button",
        buttonWidth: buttonWidth,
        $isDisabled: $isDisabled,
        children: children
    });
});
var StyledArrowDown = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_icon_KeyboardArrowDown__WEBPACK_IMPORTED_MODULE_5__["default"], {
    target: "e1v4hctf1",
    label: "StyledArrowDown"
})("transition:transform 400ms ease-in-out;transform:", function(param) {
    var open = param.open;
    return open ? "rotate(180deg)" : "rotate(0deg)";
}, ";@media only screen and (max-width:47.95em){margin-left:8px;}");
var IconWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "e1v4hctf2",
    label: "IconWrapper"
})("margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_7__/* .Spacings.SPACING_2B */ .t8.Rw, ";display:flex;");
var getFavoriteKey = function(option) {
    return [
        "value",
        "code",
        "id",
        "uid"
    ].find(function(key) {
        return Object.keys(option || {}).some(function(k) {
            return k === key;
        });
    });
};
var selectedOptionHasValueOrId = function(selectedOption) {
    var favoriteKey = getFavoriteKey(selectedOption);
    return !lodash_isNil__WEBPACK_IMPORTED_MODULE_2___default()(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption[favoriteKey]);
};
var isDefined = function(value) {
    return !(value === undefined || value === null);
};
var isSelected = function(selectedOption, option) {
    var favoriteKey = getFavoriteKey(selectedOption);
    if (isDefined(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption[favoriteKey]) && (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption[favoriteKey]) === (option === null || option === void 0 ? void 0 : option[favoriteKey])) return true;
    return false;
};
var Dropdown = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(props, ref) {
    var _options = props.options, options = _options === void 0 ? [] : _options, selectedOption = props.selectedOption, onOptionClick = props.onOptionClick, onClick = props.onClick, displayCheck = props.displayCheck, children = props.children, gridColumn = props.gridColumn, mwGridColumn = props.mwGridColumn, links = props.links, isDisabled = props.isDisabled, stripLength = props.stripLength, showSelectedBorder = props.showSelectedBorder, className = props.className, openDropDown = props.openDropDown, closeDropdown = props.closeDropdown, state = props.state, useOuterState = props.useOuterState, displayIcon = props.displayIcon, menuWidth = props.menuWidth, menuHeight = props.menuHeight, buttonWidth = props.buttonWidth, placeholder = props.placeholder, menuColor = props.menuColor, topChildren = props.topChildren, showIcon = props.showIcon, textColor = props.textColor, getKey = props.getKey, disablePortal = props.disablePortal;
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), anchorEl = _$ref[0], setAnchorEl = _$ref[1];
    var handleClick = function(event) {
        onClick();
        if (isDisabled) {
            return;
        }
        if (useOuterState) openDropDown(event.currentTarget);
        else setAnchorEl(event.currentTarget);
    };
    var handleClose = function() {
        if (useOuterState) closeDropdown();
        else setAnchorEl(null);
    };
    var handleOptionClick = function(option) {
        onOptionClick(option);
        handleClose();
    };
    var stripLabel = function(label) {
        if (stripLength && (label === null || label === void 0 ? void 0 : label.length) > stripLength) return "".concat(label.substr(0, stripLength), " ...");
        return label;
    };
    var stateOrAnchor = state || anchorEl;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(Button, {
                open: stateOrAnchor,
                onClick: handleClick,
                gridColumn: gridColumn,
                mwGridColumn: mwGridColumn,
                ref: ref,
                showSelectedBorder: showSelectedBorder && selectedOptionHasValueOrId(selectedOption),
                className: className,
                buttonWidth: buttonWidth,
                $isDisabled: isDisabled,
                children: [
                    displayIcon ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(IconWrapper, {
                        className: "iconWrapper",
                        children: displayIcon
                    }) : null,
                    selectedOption ? stripLabel(selectedOption.label || selectedOption.name || selectedOption.display_name || "No preference") : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_base_H6_H6__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        color: textColor || "var(--color-text-secondary)",
                        children: placeholder
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(StyledArrowDown, {
                        open: stateOrAnchor,
                        size: "16px",
                        color: "var(--color-text-primary)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsxs */ .BX)(_base_Menu_Menu__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                anchorEl: stateOrAnchor,
                onClose: handleClose,
                width: menuWidth,
                height: menuHeight,
                disablePortal: disablePortal,
                children: [
                    topChildren,
                    options.map(function(option, index) {
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__/* .jsx */ .tZ)(_MenuItem__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            displayCheck: displayCheck,
                            selected: isSelected(selectedOption, option),
                            option: option,
                            onClick: handleOptionClick,
                            links: links,
                            color: menuColor,
                            showIcon: showIcon
                        }, getKey(option) || index);
                    }),
                    children
                ]
            })
        ]
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (Dropdown);
Dropdown.propTypes = {
    selectedOption: prop_types__WEBPACK_IMPORTED_MODULE_10___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_10___default().any)),
    options: prop_types__WEBPACK_IMPORTED_MODULE_10___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_10___default().any)),
    onOptionClick: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().func.isRequired),
    displayCheck: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().node),
    gridColumn: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    mwGridColumn: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    links: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    stripLength: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().number),
    showSelectedBorder: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    displayIcon: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().node),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().func),
    menuWidth: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    menuHeight: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    buttonWidth: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    placeholder: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    showIcon: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    getKey: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().func),
    disablePortal: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool)
};
Dropdown.defaultProps = {
    selectedOption: null,
    options: [],
    displayCheck: false,
    showIcon: false,
    children: null,
    gridColumn: "span 4",
    mwGridColumn: "auto",
    links: false,
    stripLength: null,
    showSelectedBorder: true,
    displayIcon: null,
    menuWidth: "233px",
    menuHeight: "276px",
    buttonWidth: null,
    onClick: function() {},
    placeholder: "",
    getKey: function(option) {
        return (option === null || option === void 0 ? void 0 : option.value) || (option === null || option === void 0 ? void 0 : option.id);
    },
    disablePortal: false
};


/***/ }),

/***/ 98811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var _base_Link_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76356);
/* harmony import */ var _icon_Check__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92542);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2080);






var StyledItem = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("li", {
    target: "e10ouzx60",
    label: "StyledItem"
})("display:flex;align-items:center;padding:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_2B */ .t8.Rw, " ", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_3B */ .t8.N, ";cursor:pointer;");
var LinkedLi = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("li", {
    target: "e10ouzx61",
    label: "LinkedLi"
})("cursor:pointer;");
var GoalImage = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("img", {
    target: "e10ouzx62",
    label: "GoalImage"
})("height:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_8B */ .t8.B3, ";width:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_8B */ .t8.B3, ";margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_4__/* .Spacings.SPACING_4B */ .t8.BM, ";");
var Label = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("span", {
    target: "e10ouzx63",
    label: "Label"
})("font-size:14px;line-height:150%;color:", function(param) {
    var selected = param.selected;
    return selected ? "var(--color-i-green)" : "var(--color-text-primary)";
}, ";color:", function(param) {
    var color = param.color, selected = param.selected;
    return selected && color;
}, ";flex-grow:1;display:block;font-weight:", function(param) {
    var selected = param.selected;
    return selected ? "bold" : "initial";
}, ";");
var anchorStyle = "display: flex; align-items: center; padding: 8px 16px;";
var item = function(selected, links, option, displayCheck, onMenuClick, color, ref, showIcon) {
    var _$ref = option || {}, selGoalIcon = _$ref.icon, selGoalName = _$ref.name, as = _$ref.as, href = _$ref.href, label = _$ref.label, name = _$ref.name, display_name = _$ref.display_name;
    var goalImage = /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(GoalImage, {
        src: selGoalIcon,
        alt: selGoalName
    });
    if (links) return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(LinkedLi, {
        onClick: onMenuClick,
        ref: ref,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_base_Link_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            anchorStyle: anchorStyle,
            as: as,
            href: href,
            children: [
                showIcon && goalImage,
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Label, {
                    selected: selected,
                    color: color,
                    children: option.label || option.name || option.display_name
                }),
                selected && displayCheck && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_icon_Check__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    size: "24px",
                    color: "var(--color-i-green)"
                })
            ]
        })
    });
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(StyledItem, {
        ref: ref,
        onClick: onMenuClick,
        children: [
            showIcon && goalImage,
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Label, {
                selected: selected,
                color: color,
                children: label || name || display_name || "No preference"
            }),
            selected && displayCheck && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_icon_Check__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                size: "24px",
                color: "var(--color-i-green)"
            })
        ]
    });
};
var MenuItem = function(param, ref) {
    var option = param.option, selected = param.selected, onClick = param.onClick, displayCheck = param.displayCheck, links = param.links, color = param.color, showIcon = param.showIcon;
    var onMenuClick = function() {
        return onClick(option);
    };
    return item(selected, links, option, displayCheck, onMenuClick, color, ref, showIcon);
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(MenuItem));


/***/ }),

/***/ 49199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ FreeCourseCard_FreeCourseCard; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Base/Thumbnail/Thumbnail.tsx
var Thumbnail = __webpack_require__(75591);
// EXTERNAL MODULE: ./src/components/Base/LinearProgressBar/LinearProgressBar.jsx
var LinearProgressBar = __webpack_require__(50699);
// EXTERNAL MODULE: ./src/components/Base/Link/Link.jsx
var Link = __webpack_require__(76356);
// EXTERNAL MODULE: ./src/utils/textHelper.js
var textHelper = __webpack_require__(31309);
// EXTERNAL MODULE: ./src/models/Course.js
var Course = __webpack_require__(56046);
// EXTERNAL MODULE: ./src/events/segmentStorage.js
var segmentStorage = __webpack_require__(71250);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./src/components/Composite/CourseCard/index.js + 1 modules
var CourseCard = __webpack_require__(87414);
// EXTERNAL MODULE: ./src/components/Base/Avatar/Avatar.jsx
var Avatar = __webpack_require__(66029);
// EXTERNAL MODULE: ./src/components/Base/P2/P2.jsx
var P2 = __webpack_require__(72560);
// EXTERNAL MODULE: ./src/components/Base/Tags/Tags.jsx
var Tags = __webpack_require__(52236);
// EXTERNAL MODULE: ./src/components/Base/H6/H6.jsx
var H6 = __webpack_require__(10076);
// EXTERNAL MODULE: ./src/components/Base/Grow/Grow.jsx
var Grow = __webpack_require__(5010);
// EXTERNAL MODULE: ./src/components/Base/StarRating/StarRating.jsx
var StarRating = __webpack_require__(5894);
;// CONCATENATED MODULE: ./src/components/Composite/FreeCourseCard/FreeCourseCardDetails.jsx

/* stylelint-disable value-no-vendor-prefix */ 











var StyledFreeCourseCardDetails = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "elcm0ks0",
    label: "StyledFreeCourseCardDetails"
})("display:flex;flex-direction:column;flex:1;justify-content:space-between;text-align:left;max-width:240px;padding:", styleConstants/* Spacings.SPACING_4B */.t8.BM, " ", function(param) {
    var horizontal = param.horizontal;
    return horizontal ? styleConstants/* Spacings.SPACING_6B */.t8.BY : styleConstants/* Spacings.SPACING_4B */.t8.BM;
}, ";");
var TopicGroupTag = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Tags/* default */.Z, {
    target: "elcm0ks1",
    label: "TopicGroupTag"
})("margin-left:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";");
var CourseTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H6/* default */.Z, {
    target: "elcm0ks2",
    label: "CourseTitle"
})("margin-top:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";margin-bottom:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";color:var(--color-text-primary);");
var Educator = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "elcm0ks3",
    label: "Educator"
})("display:flex;margin-top:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";");
var EducatorAvatar = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Avatar/* default */.Z, {
    target: "elcm0ks4",
    label: "EducatorAvatar"
})("border-radius:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";");
var EducatorName = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P2/* default */.Z, {
    target: "elcm0ks5",
    label: "EducatorName"
})("margin-left:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";color:var(--color-text-primary);");
var Rating = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(StarRating/* default */.Z, {
    target: "elcm0ks6",
    label: "Rating"
})("margin-left:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";margin-right:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";");
var FreeCourseCardDetails = function(param) {
    var course = param.course, orientation = param.orientation, handleAnalytics = param.handleAnalytics;
    var ref, ref1, ref2, ref3;
    var language = course.language, conceptTopology = course.conceptTopology, name = course.name, averageRating = course.averageRating, totalRatings = course.totalRatings, authors = course.authors;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledFreeCourseCardDetails, {
        orientation: orientation,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                children: [
                    language && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tags/* default */.Z, {
                        type: "hollow",
                        children: language
                    }),
                    conceptTopology && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopicGroupTag, {
                        type: "disabled",
                        children: (0,textHelper/* textTruncate */.Th)(conceptTopology || "", 28)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                        href: (0,Course/* getLinkPath */.bc)(course),
                        as: (0,Course/* getLink */.Rg)(course),
                        onClick: handleAnalytics,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseTitle, {
                            lineClamp: 2,
                            as: "h4",
                            children: name
                        })
                    }),
                    averageRating ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Rating, {
                        rating: averageRating,
                        ratingsCount: totalRatings
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grow/* default */.Z, {}),
            (authors === null || authors === void 0 ? void 0 : (ref = authors[0]) === null || ref === void 0 ? void 0 : ref.name) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                href: "/[authorID]",
                as: "/@".concat(authors === null || authors === void 0 ? void 0 : (ref1 = authors[0]) === null || ref1 === void 0 ? void 0 : ref1.username),
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Educator, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EducatorAvatar, {
                            src: authors === null || authors === void 0 ? void 0 : (ref2 = authors[0]) === null || ref2 === void 0 ? void 0 : ref2.thumbnail,
                            size: styleConstants/* Spacings.SPACING_4B */.t8.BM
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EducatorName, {
                            children: authors === null || authors === void 0 ? void 0 : (ref3 = authors[0]) === null || ref3 === void 0 ? void 0 : ref3.name
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var FreeCourseCard_FreeCourseCardDetails = (FreeCourseCardDetails);
FreeCourseCardDetails.propTypes = {
    course: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    orientation: prop_types_default().oneOf([
        "horizontal",
        "vertical"
    ]),
    handleAnalytics: (prop_types_default()).func.isRequired
};
FreeCourseCardDetails.defaultProps = {
    orientation: "vertical"
};

;// CONCATENATED MODULE: ./src/components/Composite/FreeCourseCard/FreeCourseCard.jsx












var CardContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(CourseCard/* Container */.W2, {
    target: "e181xtg00",
    label: "CardContainer"
})("display:flex;flex:1;overflow:hidden;flex-direction:", function(param) {
    var orientation = param.orientation;
    return orientation === "horizontal" ? "row" : "column";
}, ";@media only screen and (max-width:", styleConstants/* breakpoints.mobile */.AV.mobile, "){flex:auto;}");
var StyledThumbnail = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Thumbnail/* default */.Z, {
    target: "e181xtg01",
    label: "StyledThumbnail"
})("border-top-left-radius:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";border-top-right-radius:", function(param) {
    var orientation = param.orientation;
    return orientation === "vertical" && styleConstants/* Spacings.SPACING_2B */.t8.Rw;
}, ";height:", function(param) {
    var orientation = param.orientation;
    return orientation === "horizontal" && "152px";
}, ";");
var FreeCourseCard = function(param) {
    var course = param.course, gridColumn = param.gridColumn, orientation = param.orientation, className = param.className, dataAnalytics = param.dataAnalytics, label = param.label;
    if (!course) return null;
    var handleAnalytics = function() {
        segmentStorage/* default.setItem */.Z.setItem("lpss", label);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardContainer, {
        className: className,
        gridColumn: gridColumn,
        orientation: orientation,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Link/* default */.Z, {
                href: (0,Course/* getLinkPath */.bc)(course),
                as: (0,Course/* getLink */.Rg)(course),
                onClick: handleAnalytics,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledThumbnail, {
                        imgUrl: course.thumbnail,
                        orientation: orientation,
                        dataAnalytics: "".concat(dataAnalytics, "-courseEnroll"),
                        children: course.itemCount ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseCard/* StyledTag */.w5, {
                            type: "filled",
                            children: (0,textHelper/* pluralize */._6)(course.itemCount, "lesson")
                        }) : null
                    }),
                    orientation === "vertical" && course.progress && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LinearProgressBar/* default */.Z, {
                        value: course.progress.percentage || 0,
                        width: "100%",
                        borderRadius: "0px",
                        backgroundColor: "var(--color-base-1)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FreeCourseCard_FreeCourseCardDetails, {
                course: course,
                handleAnalytics: handleAnalytics
            })
        ]
    });
};
/* harmony default export */ var FreeCourseCard_FreeCourseCard = (FreeCourseCard);
FreeCourseCard.propTypes = {
    course: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    gridColumn: (prop_types_default()).string,
    orientation: prop_types_default().oneOf([
        "horizontal",
        "vertical"
    ]),
    className: (prop_types_default()).string,
    dataAnalytics: (prop_types_default()).string,
    label: (prop_types_default()).string
};
FreeCourseCard.defaultProps = {
    gridColumn: "span 6",
    orientation: "vertical",
    className: "",
    dataAnalytics: "",
    label: ""
};


/***/ }),

/***/ 24546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _base_Thumbnail_Thumbnail__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75591);
/* harmony import */ var _models_Course__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56046);
/* harmony import */ var _hooks_useSubscribed__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83497);
/* harmony import */ var _events_segmentStorage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71250);
/* harmony import */ var _actions_analytics__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87936);
/* harmony import */ var _hooks_useGoalEventProps__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52405);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2080);
/* harmony import */ var _api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(85780);
/* harmony import */ var _api_selectors_auth__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(73060);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31309);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(43135);
/* harmony import */ var _constants_segment__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(17579);
/* harmony import */ var _cont_Syllabus_constants_getTopicGroupAssetObj__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(77608);
/* harmony import */ var _api_fetchers_search_search__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(83606);
/* harmony import */ var aquilla_core_organisms_CourseCard__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(48866);
/* harmony import */ var _utils_pushRoute__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(751);
/* harmony import */ var _placeholderCourseThumbail_CoursePlaceholder__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(7125);
/* harmony import */ var _placeholderCourseThumbail_SvgThumbnail__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(95597);
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(53915);
























var SvgCourseThumbnail = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_placeholderCourseThumbail_SvgThumbnail__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
    target: "e73j3uj0",
    label: "SvgCourseThumbnail"
})("width:272px;height:", function(param) {
    var $orientation = param.$orientation;
    return $orientation === "horizontal" ? "152px" : "auto";
}, ";", _styles_index__WEBPACK_IMPORTED_MODULE_8__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{width:100%;border-radius:0;}");
var CourseThumbnail = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_Thumbnail_Thumbnail__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    target: "e73j3uj1",
    label: "CourseThumbnail"
})("width:272px;height:", function(param) {
    var orientation = param.orientation;
    return orientation === "horizontal" && "152px";
}, ";", _styles_index__WEBPACK_IMPORTED_MODULE_8__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{width:100%;border-radius:0;}");
var PlaceholderThumbnail = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_placeholderCourseThumbail_CoursePlaceholder__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
    target: "e73j3uj2",
    label: "PlaceholderThumbnail"
})("height:100%;width:100%;transform:scale(1.02);background-color:var(--color-divider);object-fit:cover;@media only screen and (max-width:47.95em){transform:scale(1);}");
var DefaultThumbnail = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e73j3uj3",
    label: "DefaultThumbnail"
})("position:relative;overflow:hidden;border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_8__/* .Spacings.SPACING_2B */ .t8.Rw, ";");
var getTopicName = function(topicGroups, topic) {
    var ref, ref1;
    var topicName = (topicGroups === null || topicGroups === void 0 ? void 0 : (ref = topicGroups[0]) === null || ref === void 0 ? void 0 : ref.name) || (topicGroups === null || topicGroups === void 0 ? void 0 : (ref1 = topicGroups[0]) === null || ref1 === void 0 ? void 0 : ref1.title) || "";
    if (topic && topic.uid) {
        topicName = topic.name;
    }
    return topicName;
};
var PlusCourseCard = function(param) {
    var _orientation = param.orientation, orientation = _orientation === void 0 ? "vertical" : _orientation, _topic = param.topic, topic = _topic === void 0 ? {} : _topic, _type = param.type, type = _type === void 0 ? "" : _type, _imageBorderRadius = param.imageBorderRadius, imageBorderRadius = _imageBorderRadius === void 0 ? "0px" : _imageBorderRadius, _showProgress = param.showProgress, showProgress = _showProgress === void 0 ? false : _showProgress, _dataAnalytics = param.dataAnalytics, dataAnalytics = _dataAnalytics === void 0 ? "" : _dataAnalytics, _label = param.label, label = _label === void 0 ? "" : _label, _lastPrimarySource = param.lastPrimarySource, lastPrimarySource = _lastPrimarySource === void 0 ? "" : _lastPrimarySource, _searchData = param.searchData, searchData = _searchData === void 0 ? {} : _searchData, _hideLessonCount = param.hideLessonCount, hideLessonCount = _hideLessonCount === void 0 ? false : _hideLessonCount, _onCardClick = param.onCardClick, onCardClick = _onCardClick === void 0 ? function() {} : _onCardClick, course = param.course, index = param.index;
    var ref;
    var authors = course.authors, language = course.language, showAsLesson = course.showAsLesson, nextTrack = course.nextTrack, name = course.name;
    var displayName = showAsLesson ? nextTrack.name : name;
    var goalUID = (course === null || course === void 0 ? void 0 : course.goalUid) || (course === null || course === void 0 ? void 0 : (ref = course.goal) === null || ref === void 0 ? void 0 : ref.uid);
    var isSubscribed = (0,_hooks_useSubscribed__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(goalUID);
    var isLoggedIn = (0,_api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_api_selectors_auth__WEBPACK_IMPORTED_MODULE_20__/* .getIsLoggedIn */ .M7);
    var goalSegmentData = (0,_hooks_useGoalEventProps__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        goalUID: goalUID
    });
    var topicGroups = course.topicGroups;
    var topicName = getTopicName(topicGroups, topic);
    var color = (0,_cont_Syllabus_constants_getTopicGroupAssetObj__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(topicName).color;
    var meUID = (0,_api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_api_selectors_auth__WEBPACK_IMPORTED_MODULE_20__/* .getMeUid */ .Up);
    var coverPhoto = course.coverPhotoV1 || course.coverPhoto || course.thumbnail || (0,_models_Course__WEBPACK_IMPORTED_MODULE_3__/* .getDefaultThumbnail */ .mI)(course);
    var showProgressbar = isLoggedIn && isSubscribed && course.itemCount > 0 && showProgress;
    if (!course) return null;
    var isLive = course.isLive;
    var handleAnalytics = function() {
        var courseData = course || {};
        var courseUID = courseData.uid || "";
        // Means card was rendered on a search page
        if (course.showAsLesson) {
            _actions_analytics__WEBPACK_IMPORTED_MODULE_6__/* .segment.track */ .EX.track("Lesson Viewed", {
                last_primary_source: lastPrimarySource,
                last_primary_source_section: label
            });
        }
        if (type === "search") {
            var nSearchData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, searchData);
            delete nSearchData.query;
            var position = nSearchData.position ? nSearchData.position : "See all";
            // send segment search result clicked event
            _actions_analytics__WEBPACK_IMPORTED_MODULE_6__/* .segment.track */ .EX.track(_constants_segment__WEBPACK_IMPORTED_MODULE_12__/* .SEARCH_RESULT_CLICKED */ .dW7, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, goalSegmentData), {
                sub_position: index + 1,
                is_object_plus: courseData.forPlus,
                is_object_special: courseData.isSpecial,
                educator_uid: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_10__/* .getCommaSeparatedUIDs */ .$V)(authors),
                educator_username: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_10__/* .getCommaSeparatedUIDs */ .$V)(authors, "username"),
                educator_name: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_10__/* .getCommaSeparatedUIDs */ .$V)(authors, "name"),
                last_primary_source: _constants_segment__WEBPACK_IMPORTED_MODULE_12__/* .SEARCH_RESULT_PAGE */ .jDH,
                last_primary_source_section: "Courses",
                search_section: "Global",
                current_screen: "Courses",
                eventName: _constants_segment__WEBPACK_IMPORTED_MODULE_12__/* .SEARCH_RESULT_CLICKED */ .dW7,
                eventType: "click",
                version: 2,
                objectID: "".concat(searchData.object_type, ":").concat(courseUID),
                userToken: meUID
            }), nSearchData), {
                position: position
            }), _constants_index__WEBPACK_IMPORTED_MODULE_11__/* .evtNameCategoryMap.WITHOUT_CATEGORY */ .xK.WITHOUT_CATEGORY);
            (0,_api_fetchers_search_search__WEBPACK_IMPORTED_MODULE_14__/* .updateRecentSearchLog */ .a)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, searchData), {
                entity_id: "".concat(searchData.object_type, ":").concat(courseUID),
                goal_uid: goalUID
            }));
        }
        if (lastPrimarySource === "lesson page") {
            _actions_analytics__WEBPACK_IMPORTED_MODULE_6__/* .segment.track */ .EX.track(course.isSpecial ? "CLX Lesson View" : "Course Viewed", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({
                last_primary_source: lastPrimarySource,
                last_primary_source_section: label || _events_segmentStorage__WEBPACK_IMPORTED_MODULE_5__/* ["default"].getItem */ .Z.getItem("lpss"),
                course_uid: course.uid,
                course_title: course.name,
                start_date: course.startsAt,
                end_date: course.endsAt,
                educator_uid: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_10__/* .wordsToSentence */ .nt)(course.authors, "uid", ",", ","),
                educator_username: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_10__/* .wordsToSentence */ .nt)(course.authors, "username", ",", ","),
                is_offline_course: (courseData === null || courseData === void 0 ? void 0 : courseData.courseType) === _constants_index__WEBPACK_IMPORTED_MODULE_11__/* .programmeTypes.HYBRID_COURSE */ .h7.HYBRID_COURSE
            }, goalSegmentData));
        }
        onCardClick();
        // Adding LPSS to segment from label property and deleting it on class exit
        // in case property is not deleted removing it if label is not passed
        if (label) _events_segmentStorage__WEBPACK_IMPORTED_MODULE_5__/* ["default"].setItem */ .Z.setItem("lpss", label);
        else _events_segmentStorage__WEBPACK_IMPORTED_MODULE_5__/* ["default"].deleteItem */ .Z.deleteItem("lpss");
        var route = {
            href: (0,_models_Course__WEBPACK_IMPORTED_MODULE_3__/* .getLinkPath */ .bc)(course),
            as: (0,_models_Course__WEBPACK_IMPORTED_MODULE_3__/* .getLink */ .Rg)(course)
        };
        (0,_utils_pushRoute__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(route.href, route.as);
    };
    var getVariant = function() {
        if (isLive) return "live";
        return showProgressbar ? "continue_watching" : "missed";
    };
    var thumbail = function() {
        return coverPhoto ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__/* .jsx */ .tZ)(CourseThumbnail, {
            width: 272,
            height: 152,
            layout: "intrinsic",
            alt: course.newThumbnail ? "new-thumbnail" : "thumbnail",
            imgUrl: coverPhoto,
            orientation: orientation,
            borderRadius: imageBorderRadius,
            "data-analytics": "".concat(dataAnalytics, "-courseCard")
        }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__/* .jsx */ .tZ)(SvgCourseThumbnail, {
            // @ts-ignore
            as: DefaultThumbnail,
            $orientation: orientation,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__/* .jsx */ .tZ)(PlaceholderThumbnail, {
                color: color
            })
        });
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__/* .jsx */ .tZ)(aquilla_core_organisms_CourseCard__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
        detailsLine: (0,_util__WEBPACK_IMPORTED_MODULE_19__/* .getCourseInfo */ .zf)(hideLessonCount, course),
        educatorName: (0,_util__WEBPACK_IMPORTED_MODULE_19__/* .getAuthorInfo */ .a8)(course).authorName,
        href: (0,_models_Course__WEBPACK_IMPORTED_MODULE_3__/* .getLink */ .Rg)(course),
        langLabel: language,
        onClick: handleAnalytics,
        progress: course.lessonsCompleted / course.itemCount * 100,
        thumbnail: thumbail,
        title: displayName,
        topicColor: color,
        topicName: topicName,
        educatorLink: (0,_util__WEBPACK_IMPORTED_MODULE_19__/* .getAuthorInfo */ .a8)(course).authorID,
        variant: getVariant()
    }, course.uid);
};
/* harmony default export */ __webpack_exports__["Z"] = (PlusCourseCard);


/***/ }),

/***/ 73993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D4": function() { return /* binding */ getIsPartnerEducatorBatch; },
/* harmony export */   "DJ": function() { return /* binding */ getOfferEndMessage; },
/* harmony export */   "Eg": function() { return /* binding */ getBatchType; },
/* harmony export */   "Ej": function() { return /* binding */ DEFAULT_SUBJECT_VALUE; },
/* harmony export */   "Ic": function() { return /* binding */ getBatchReferralInStorage; },
/* harmony export */   "Lk": function() { return /* binding */ SESSION_TYPE_MAP; },
/* harmony export */   "MB": function() { return /* binding */ EDUCATOR_TYPES; },
/* harmony export */   "Rf": function() { return /* binding */ FETCH_STORE_SYLLABUS_VALUES; },
/* harmony export */   "Sf": function() { return /* binding */ getIsStoreSyllabus; },
/* harmony export */   "Tv": function() { return /* binding */ BATCH_CONTENT_TYPE_MAP; },
/* harmony export */   "ax": function() { return /* binding */ getEnrollmentEndMessage; },
/* harmony export */   "bL": function() { return /* binding */ getIsStoreModule; },
/* harmony export */   "gx": function() { return /* binding */ getHasStorePurchase; },
/* harmony export */   "ko": function() { return /* binding */ getAccessEndDate; },
/* harmony export */   "nQ": function() { return /* binding */ getIsStorePath; },
/* harmony export */   "oc": function() { return /* binding */ LESSON_ITEMS_ON_BATCH_PAGE; },
/* harmony export */   "tn": function() { return /* binding */ getSkuBasedEventProps; },
/* harmony export */   "v7": function() { return /* binding */ BATCH_CONTENT_TYPE_ID; },
/* harmony export */   "z_": function() { return /* binding */ setBatchReferralInStorage; },
/* harmony export */   "zm": function() { return /* binding */ getActiveSku; }
/* harmony export */ });
/* unused harmony exports BATCH_TYPE, removeStoreBatchInStorage */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97428);
/* harmony import */ var _utils_getItemFromSessionStorage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97903);
/* harmony import */ var _utils_isEmpty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29626);






var BATCH_CONTENT_TYPE_ID = 500;
var BATCH_TYPE = {
    MODULE: "Module",
    PLAYLIST: "Playlist"
};
var BATCH_CONTENT_TYPE_MAP = {
    LIVE: "Live",
    RECORDED: "Recorded",
    LIVE_RECORDED: "Live + Recorded",
    HYBRID: "HYBRID",
    CENTER: "Center",
    OFFLINE: "Offline"
};
var STORE_BATCH_KEY = "storeBatchReferralCodes";
var SESSION_TYPE_MAP = {
    ALL: "1",
    CLASSES: "2",
    TESTS: "3"
};
var LESSON_ITEMS_ON_BATCH_PAGE = {
    START: 0,
    END: 3
};
var DEFAULT_SUBJECT_VALUE = "ALL";
var EDUCATOR_TYPES = {
    PLUS: 1,
    PARTNER: 2
};
var FETCH_STORE_SYLLABUS_VALUES = {
    LIMIT: 10,
    OFFSET: 0
};
var getIsStorePath = function(route) {
    return route.indexOf("store/batch/") >= 0;
};
var getActiveSku = function(purchaseInfo) {
    var skus = purchaseInfo === null || purchaseInfo === void 0 ? void 0 : purchaseInfo.skus;
    return skus === null || skus === void 0 ? void 0 : skus[0];
};
var getIsPartnerEducatorBatch = function(batchDetails) {
    return (batchDetails === null || batchDetails === void 0 ? void 0 : batchDetails.educatorType) === EDUCATOR_TYPES.PARTNER;
};
var getIsStoreSyllabus = function(param) {
    var additionalFeatures = param.additionalFeatures;
    return additionalFeatures ? (additionalFeatures === null || additionalFeatures === void 0 ? void 0 : additionalFeatures.indexOf(BATCH_TYPE.PLAYLIST)) !== -1 : false;
};
var getIsStoreModule = function(param) {
    var additionalFeatures = param.additionalFeatures;
    return additionalFeatures ? (additionalFeatures === null || additionalFeatures === void 0 ? void 0 : additionalFeatures.indexOf(BATCH_TYPE.MODULE)) !== -1 : false;
};
var getHasStorePurchase = function(batchUID, purchaseInfo) {
    var ref;
    var purchases = purchaseInfo === null || purchaseInfo === void 0 ? void 0 : (ref = purchaseInfo.metaInfo) === null || ref === void 0 ? void 0 : ref.latestUserSkusTypeWise;
    if (purchases && purchases[BATCH_CONTENT_TYPE_ID]) {
        var batchPurchases = purchases[BATCH_CONTENT_TYPE_ID];
        var currentBatchActivePurchase = batchPurchases.find(function(purchase) {
            return purchase.objectUid === batchUID;
        });
        return !!(currentBatchActivePurchase && !(0,_utils_isEmpty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(currentBatchActivePurchase));
    }
    return false;
};
var getEnrollmentEndMessage = function(date) {
    if (!date) return "";
    var relativeDate = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .getRelativeDayOrCurrentDateWithTDays */ .Aw)(date, true, 7, true);
    var isRelativeDateTodayTomorrow = _utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .todayTomorrowConfig.some */ .Wb.some(function(day) {
        return day === relativeDate;
    });
    if (!relativeDate) {
        return "";
    }
    if (isRelativeDateTodayTomorrow) {
        return "Enrolment ends ".concat(relativeDate);
    }
    if (relativeDate <= 7 && relativeDate > 0) {
        return "Enrolment ends in ".concat(relativeDate, " days");
    }
    return "Enrolment ends on ".concat(relativeDate);
};
var getOfferEndMessage = function(date) {
    if (!date) return "";
    var relativeDate = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .getRelativeDayOrCurrentDateWithTDays */ .Aw)(date, true, 7, true);
    var isRelativeDateTodayTomorrow = _utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .todayTomorrowConfig.some */ .Wb.some(function(day) {
        return day === relativeDate;
    });
    if (!relativeDate) {
        return "";
    }
    if (isRelativeDateTodayTomorrow) {
        return "Offer ends ".concat(relativeDate);
    }
    if (relativeDate <= 7 && relativeDate > 0) {
        return "Offer ends in ".concat(relativeDate, " days");
    }
    return "Offer ends on ".concat(relativeDate);
};
var getAccessEndDate = function(purchaseInfo, batchUID, isStoreRoute, isSubscribed) {
    var ref;
    var activeSku = getActiveSku(purchaseInfo);
    if (activeSku && !(0,_utils_isEmpty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(activeSku) && isStoreRoute && !isSubscribed) {
        return (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .getRegularDate */ .Wg)(activeSku === null || activeSku === void 0 ? void 0 : activeSku.accessEndDate);
    }
    var purchases = purchaseInfo === null || purchaseInfo === void 0 ? void 0 : (ref = purchaseInfo.metaInfo) === null || ref === void 0 ? void 0 : ref.latestUserSkusTypeWise;
    if (purchases && purchases[BATCH_CONTENT_TYPE_ID]) {
        var batchPurchases = purchases[BATCH_CONTENT_TYPE_ID];
        var currentBatchActivePurchase = batchPurchases.find(function(purchase) {
            return purchase.objectUid === batchUID;
        });
        return currentBatchActivePurchase && (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .getRegularDate */ .Wg)(currentBatchActivePurchase.expiredAt);
    }
};
var getBatchType = function(contentType) {
    if (contentType === BATCH_CONTENT_TYPE_MAP.LIVE_RECORDED || contentType === BATCH_CONTENT_TYPE_MAP.RECORDED) {
        return "Recorded";
    }
    return contentType;
};
var getSkuBasedEventProps = function(activeSku, batchDetails) {
    return {
        entity_content_type: "Batch",
        entity_title: batchDetails === null || batchDetails === void 0 ? void 0 : batchDetails.name,
        entity_uid: batchDetails === null || batchDetails === void 0 ? void 0 : batchDetails.uid,
        last_primary_source: "Store",
        subscription_type: "Store Subscription",
        offer_price: activeSku === null || activeSku === void 0 ? void 0 : activeSku.price,
        offer_end_date: (activeSku === null || activeSku === void 0 ? void 0 : activeSku.priceEffectiveTill) || undefined,
        subscription_price: (activeSku === null || activeSku === void 0 ? void 0 : activeSku.maxRetailPrice) || (activeSku === null || activeSku === void 0 ? void 0 : activeSku.price),
        subscription_duration: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_0__/* .getDateDifference */ .hM)(activeSku === null || activeSku === void 0 ? void 0 : activeSku.accessEndDate),
        entity_content_subtype: getBatchType(batchDetails === null || batchDetails === void 0 ? void 0 : batchDetails.contentType),
        educator_type: (batchDetails === null || batchDetails === void 0 ? void 0 : batchDetails.educatorType) === EDUCATOR_TYPES.PARTNER ? "Partner" : "Plus"
    };
};
var getBatchReferralInStorage = function(batchUID) {
    try {
        var referralCodesStr = (0,_utils_getItemFromSessionStorage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(STORE_BATCH_KEY);
        var referralCodes = !!referralCodesStr && JSON.parse(referralCodesStr);
        return referralCodes && referralCodes[batchUID];
    } catch (e) {
        return null;
    }
};
var setBatchReferralInStorage = function(batchUID, code) {
    try {
        var referralCodesStr = (0,_utils_getItemFromSessionStorage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(STORE_BATCH_KEY);
        var referralCodes = !!referralCodesStr && JSON.parse(referralCodesStr);
        sessionStorage.setItem(STORE_BATCH_KEY, JSON.stringify((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, referralCodes), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, batchUID, code))));
    } catch (e) {
        return null;
    }
};
var removeStoreBatchInStorage = function() {
    sessionStorage.removeItem(STORE_BATCH_KEY);
};



/***/ }),

/***/ 77608:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var topicGroupColorMap = {
    A: "#DE4B9B",
    B: "#00B3B3",
    C: "#8873FF",
    D: "#2894D1",
    E: "#F1B334",
    F: "#FF986C",
    G: "#64BEFF",
    H: "#5873FF",
    I: "#FF6694",
    J: "#27B772",
    K: "#CF866F",
    L: "#FF932F",
    M: "#DE4B9B",
    N: "#00B3B3",
    O: "#8873FF",
    P: "#2894D1",
    Q: "#F1B334",
    R: "#FF986C",
    S: "#64BEFF",
    T: "#5873FF",
    U: "#FF6694",
    V: "#27B772",
    W: "#CF866F",
    X: "#FF932F",
    Y: "#DE4B9B",
    Z: "#00B3B3"
};
var getTopicGroupAssetObj = function(title) {
    if (!title) return {};
    var alphabet = title.charAt(0) || "A";
    return {
        color: topicGroupColorMap[alphabet],
        icon: "subjects-icons/Type-".concat(alphabet, ".svg")
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (getTopicGroupAssetObj);


/***/ }),

/***/ 92542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var Check = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M32.767 56.1c-0.003 0-0.008 0-0.012 0-0.687 0-1.308-0.28-1.755-0.733l-12.767-12.767c-0.416-0.445-0.671-1.045-0.671-1.704 0-1.381 1.119-2.5 2.5-2.5 0.659 0 1.259 0.255 1.706 0.672l-0.001-0.001 11 10.933 25.467-25.433c0.449-0.46 1.074-0.745 1.767-0.745s1.318 0.285 1.766 0.745l0 0.001c0.452 0.452 0.731 1.077 0.731 1.767s-0.279 1.314-0.731 1.767v0l-27.233 27.2c-0.434 0.49-1.064 0.798-1.766 0.8h-0z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Check);


/***/ }),

/***/ 21572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var KeyboardArrowDown = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M39.8 52.033c-0.003 0-0.008 0-0.012 0-0.687 0-1.308-0.28-1.755-0.733l-20-20c-0.49-0.458-0.796-1.108-0.796-1.829 0-1.381 1.119-2.5 2.5-2.5 0.721 0 1.371 0.306 1.828 0.794l0.001 0.001 18.233 18.233 18.233-18.233c0.445-0.416 1.045-0.671 1.704-0.671 1.381 0 2.5 1.119 2.5 2.5 0 0.659-0.255 1.259-0.672 1.706l0.001-0.001-20 20c-0.447 0.453-1.068 0.733-1.755 0.733-0.004 0-0.008 0-0.012 0h0.001z"
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (KeyboardArrowDown);


/***/ }),

/***/ 52885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var StarFilled = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M72.367 32.5c-0.296-0.892-1.055-1.552-1.986-1.698l-0.014-0.002-19.433-2.833-8.7-17.6c-0.462-0.765-1.289-1.269-2.233-1.269s-1.771 0.504-2.227 1.257l-0.007 0.012-8.7 17.6-19.433 2.833c-1.211 0.188-2.126 1.223-2.126 2.472 0 0.704 0.291 1.34 0.759 1.794l0.001 0.001 14.033 13.7-3.333 19.333c-0.023 0.127-0.036 0.274-0.036 0.423 0 0.836 0.405 1.577 1.029 2.038l0.007 0.005c0.374 0.235 0.829 0.375 1.317 0.375s0.942-0.14 1.327-0.381l-0.010 0.006 17.4-8.967 17.367 9.133c0.337 0.188 0.739 0.299 1.166 0.3h0c0.001 0 0.003 0 0.005 0 1.381 0 2.5-1.119 2.5-2.5 0-0.153-0.014-0.303-0.040-0.449l0.002 0.015-3.333-19.333 14.033-13.7c0.485-0.452 0.787-1.094 0.787-1.806 0-0.272-0.044-0.533-0.125-0.778l0.005 0.017z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (StarFilled);


/***/ }),

/***/ 93496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2080);

/* eslint-disable no-else-return */ 



var StyledCarousel = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "eq1k4de0",
    label: "StyledCarousel"
})("display:grid;grid-template-columns:repeat(18,32px);grid-gap:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_4B */ .t8.BM, ";grid-column:span 18;@media only screen and (max-width:47.95em){grid-template-columns:repeat(10,1fr);grid-column:span 10;grid-column-gap:16px;grid-row-gap:16px;}");
var CourseCarousel = function(param) {
    var number = param.number, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StyledCarousel, {
        $number: number,
        children: children
    });
};
CourseCarousel.propTypes = {
    number: function number(props, propName, componentName) {
        if (typeof props[propName] !== "number") {
            return new Error("Invalid type of ".concat(propName, " supplied to ").concat(componentName, " Validation failed."));
        } else if (props[propName] > 3) {
            return new Error("Expected max value for ".concat(propName, " is 3 but supplied greater value to ").concat(componentName, " Validation failed."));
        }
    },
    children: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired)
};
CourseCarousel.defaultProps = {
    number: 3
};
/* harmony default export */ __webpack_exports__["Z"] = (CourseCarousel);


/***/ }),

/***/ 10914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CourseCard_CourseCarousel; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Skeletons/Carousel/Carousel.jsx
var Carousel = __webpack_require__(93496);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Skeleton/Skeleton.js
var Skeleton = __webpack_require__(58365);
// EXTERNAL MODULE: ./src/utils/boxShadowGenerator.js
var boxShadowGenerator = __webpack_require__(87312);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./src/stores/selectors/darkModeStatusSelectors.js
var darkModeStatusSelectors = __webpack_require__(57054);
// EXTERNAL MODULE: ./src/stores/useDarkModeStatus.js
var useDarkModeStatus = __webpack_require__(3458);
;// CONCATENATED MODULE: ./src/components/Skeletons/CourseCard/CourseCard.jsx









var StyledPlusCourseCard = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1wi5id40",
    label: "StyledPlusCourseCard"
})("background-color:var(--color-base-1);border-radius:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";box-shadow:", (0,boxShadowGenerator/* default */.Z)(), ";overflow:hidden;grid-column:span 6;@media only screen and (max-width:", styleConstants/* breakpoints.mobile */.AV.mobile, "){grid-column:span 11;}");
var StyledSkeleton = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Skeleton/* default */.Z, {
    target: "e1wi5id41",
    label: "StyledSkeleton"
})("@media only screen and (max-width:", styleConstants/* breakpoints.mobile */.AV.mobile, "){&.thumbnail{width:100% !important;}}", function(param) {
    var $isDarkModeOn = param.$isDarkModeOn;
    return $isDarkModeOn && "background-color: var(--color-base-1);";
});
var StyledPlusCourseCardDetails = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1wi5id42",
    label: "StyledPlusCourseCardDetails"
})("display:flex;flex-direction:column;justify-content:space-between;background-color:var(--color-base-1);text-align:left;padding:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";");
var CourseCard = function(param) {
    var className = param.className;
    var isDarkModeOn = (0,useDarkModeStatus/* default */.Z)(darkModeStatusSelectors/* getIsDarkModeOn */.q1);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledPlusCourseCard, {
        className: className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSkeleton, {
                variant: "rect",
                width: 272,
                height: 153,
                className: "thumbnail",
                $isDarkModeOn: isDarkModeOn
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledPlusCourseCardDetails, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSkeleton, {
                        height: 22,
                        width: "20%",
                        style: {
                            marginBottom: 8
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSkeleton, {
                        height: 20,
                        width: "100%",
                        style: {
                            marginBottom: 8
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSkeleton, {
                        height: 20,
                        width: "30%",
                        style: {
                            marginBottom: 8
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSkeleton, {
                        height: 12,
                        width: "70%",
                        style: {
                            marginBottom: 16
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSkeleton, {
                        height: 18,
                        width: "40%"
                    })
                ]
            })
        ]
    });
};
CourseCard.propTypes = {
    className: (prop_types_default()).string
};
CourseCard.defaultProps = {
    className: ""
};
/* harmony default export */ var CourseCard_CourseCard = (CourseCard);

;// CONCATENATED MODULE: ./src/components/Skeletons/CourseCard/CourseCarousel.jsx




var CourseCarousel = function(param) {
    var number = param.number, gridColumn = param.gridColumn;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Carousel/* default */.Z, {
        number: number,
        gridColumn: gridColumn,
        children: new Array(number).fill(0).map(function(val, index) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseCard_CourseCard, {}, String(index));
        })
    });
};
CourseCarousel.propTypes = {
    number: (prop_types_default()).number,
    gridColumn: (prop_types_default()).string
};
CourseCarousel.defaultProps = {
    number: 3,
    gridColumn: "span 18"
};
/* harmony default export */ var CourseCard_CourseCarousel = (CourseCarousel);


/***/ }),

/***/ 24891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ae": function() { return /* binding */ fetchCalendarData; },
/* harmony export */   "E_": function() { return /* binding */ updateBatchScheduleWeek; },
/* harmony export */   "H6": function() { return /* binding */ fetchCoursesInConcept; },
/* harmony export */   "MU": function() { return /* binding */ enrollInTrialClasses; },
/* harmony export */   "Mf": function() { return /* binding */ fetchScheduledClasses; },
/* harmony export */   "Og": function() { return /* binding */ fetchBatches; },
/* harmony export */   "Oy": function() { return /* binding */ fetchBatchFaq; },
/* harmony export */   "Rs": function() { return /* binding */ fetchTopicsCovered; },
/* harmony export */   "WU": function() { return /* binding */ fetchTopicsWithChildren; },
/* harmony export */   "aF": function() { return /* binding */ fetchItemsInCourse; },
/* harmony export */   "ff": function() { return /* binding */ fetchSimilarBatches; },
/* harmony export */   "hq": function() { return /* binding */ fetchBatchData; },
/* harmony export */   "qd": function() { return /* binding */ enrollInBatch; },
/* harmony export */   "zt": function() { return /* binding */ fetchBatchScheduleWeek; }
/* harmony export */ });
/* unused harmony exports fetchSchedule, fetchTestSeries, fetchBatchUpdates, fetchTrialClasses, fetchBatchFeedbacks */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var normalizr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82677);
/* harmony import */ var _utils_paginateAction__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72894);
/* harmony import */ var _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54051);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94336);
/* harmony import */ var _schemas__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38037);







var fetchBatchData = function(batchUID) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .batchTypes.FETCH_BATCH_INFO */ .yt.FETCH_BATCH_INFO,
            endpoint: "v2/batch/".concat(batchUID, "/details"),
            method: "get",
            key: batchUID,
            schema: new normalizr__WEBPACK_IMPORTED_MODULE_3__/* .schema.Object */ .fK.Object({
                batch: _schemas__WEBPACK_IMPORTED_MODULE_2__/* .batchSchema */ .kq
            }),
            entityType: "batch"
        });
    };
};
var fetchTopicsCovered = function(batchUID) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .batchTypes.FETCH_TOPICS_COVERED */ .yt.FETCH_TOPICS_COVERED,
            endpoint: "v1/batch/".concat(batchUID, "/topics/?level=30"),
            method: "get",
            key: batchUID
        });
    };
};
var fetchTopicsWithChildren = function(batchUID, topicUID) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .batchTypes.FETCH_TOPICS_WITH_CHILDREN */ .yt.FETCH_TOPICS_WITH_CHILDREN,
            endpoint: "v1/batch/".concat(batchUID, "/children/?parent_uid=").concat(topicUID),
            method: "get",
            key: "".concat(batchUID, "_").concat(topicUID)
        });
    };
};
var getItemsInCourse = function(courseUID, conceptUID, resetWithoutEmpty) {
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .batchTypes.FETCH_ITEMS_IN_COURSE */ .yt.FETCH_ITEMS_IN_COURSE,
            endpoint: next,
            method: "get",
            key: "".concat(conceptUID, "_").concat(courseUID),
            resetWithoutEmpty: resetWithoutEmpty,
            schema: _schemas__WEBPACK_IMPORTED_MODULE_2__/* .paginatorListSchema */ .EH,
            directPaginatedEntity: true,
            entityType: "item",
            processData: function(data) {
                var newData = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, data), {
                    results: []
                });
                if (data.results) {
                    data.results.map(function(item) {
                        var itemData = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, item, item.properties), {
                            courseUID: item.properties.programme.uid,
                            courseSlug: item.properties.programme.slug,
                            goal: item.properties.programme.goal
                        });
                        delete itemData.properties;
                        delete itemData.programme;
                        newData.results.push(itemData);
                        return itemData;
                    });
                }
                return newData;
            }
        };
    };
};
var fetchItemsInCourse = function(batchUID, conceptUID, courseUID, nextPage) {
    var resetWithoutEmpty = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("v1/batch/".concat(batchUID, "/lesson_of_concept_in_programme/?concept_uid=").concat(conceptUID, "&collection_uid=").concat(courseUID), getItemsInCourse(courseUID, conceptUID, resetWithoutEmpty), "itemsInCourse", "".concat(conceptUID, "_").concat(courseUID), resetWithoutEmpty)(nextPage);
};
var enrollInBatch = function(batchUID, enroll) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .batchTypes.ENROLL_IN_BATCH */ .yt.ENROLL_IN_BATCH,
            endpoint: "v1/batch/".concat(batchUID, "/enroll/"),
            method: "post",
            batchUID: batchUID,
            enroll: enroll,
            data: {
                enroll: enroll
            }
        });
    };
};
var getSchedule = function(batchUID, epoch, resetWithoutEmpty) {
    return function(next) {
        return {
            type: batchTypes.FETCH_SCHEDULE,
            endpoint: next,
            method: "get",
            key: "".concat(batchUID, "_").concat(epoch),
            resetWithoutEmpty: resetWithoutEmpty,
            schema: paginatorListSchema,
            directPaginatedEntity: true,
            entityType: "item",
            processData: function(data) {
                var newData = _object_spread_props(_object_spread({}, data), {
                    results: []
                });
                if (data.results) {
                    data.results.map(function(item) {
                        var itemData = _object_spread_props(_object_spread({}, item, item.properties), {
                            courseUID: item.properties.programme.uid,
                            courseSlug: item.properties.programme.slug,
                            goal: item.properties.programme.goal
                        });
                        delete itemData.properties;
                        delete itemData.programme;
                        newData.results.push(itemData);
                        return itemData;
                    });
                }
                return newData;
            }
        };
    };
};
var fetchSchedule = function(batchUID, epoch, timezoneDifference, nextPage) {
    var resetWithoutEmpty = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    return paginateAction("v1/batch/".concat(batchUID, "/schedule/?offset=").concat(epoch, "&timezone_difference=").concat(timezoneDifference, "&limit=6"), getSchedule(batchUID, epoch, resetWithoutEmpty), "batchSchedule", batchUID, resetWithoutEmpty)(nextPage);
};
var getTestSeries = function(batchUID, resetWithoutEmpty) {
    return function(next) {
        return {
            type: batchTypes.FETCH_TEST_SERIES,
            endpoint: next,
            method: "get",
            key: batchUID,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: paginatorListSchema,
            directPaginatedEntity: true,
            entityType: "course"
        };
    };
};
var fetchTestSeries = function(batchUID, nextPage) {
    var resetWithoutEmpty = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return paginateAction("v1/batch/".concat(batchUID, "/test_series?limit=100"), getTestSeries(batchUID, resetWithoutEmpty), "batchTestSeries", batchUID, resetWithoutEmpty)(nextPage);
};
var getCoursesInConcept = function(key, resetWithoutEmpty) {
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .batchTypes.FETCH_COURSES_IN_CONCEPT */ .yt.FETCH_COURSES_IN_CONCEPT,
            endpoint: next,
            method: "get",
            key: key,
            resetWithoutEmpty: resetWithoutEmpty,
            schema: _schemas__WEBPACK_IMPORTED_MODULE_2__/* .paginatorListSchema */ .EH,
            directPaginatedEntity: true,
            entityType: "course"
        };
    };
};
var fetchCoursesInConcept = function(batchUID, conceptUID, nextPage) {
    var resetWithoutEmpty = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var key = "".concat(batchUID, "_").concat(conceptUID);
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("v1/batch/".concat(batchUID, "/lessons_in_concepts/?concept_uid=").concat(conceptUID, "&limit=3"), getCoursesInConcept(key, resetWithoutEmpty), "conceptCourses", key, resetWithoutEmpty)(nextPage);
};
var fetchCalendarData = function(batchUID, time) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .batchTypes.FETCH_CALENDAR_DATA */ .yt.FETCH_CALENDAR_DATA,
            endpoint: "v1/batch/".concat(batchUID, "/count/?epoch_time=").concat(Math.round(time / 1000), "&timezone_difference=330"),
            method: "get",
            month: new Date(time).getMonth(),
            batchUID: batchUID
        });
    };
};
var fetchScheduledClasses = function(batchUID) {
    var url = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", direction = arguments.length > 2 ? arguments[2] : void 0, resetWithoutEmpty = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .batchTypes.FETCH_SCHEDULED_CLASSES */ .yt.FETCH_SCHEDULED_CLASSES,
            endpoint: url,
            method: "get",
            schema: {
                results: [
                    {
                        item: _schemas__WEBPACK_IMPORTED_MODULE_2__/* .itemSchema */ .cq
                    }
                ]
            },
            key: batchUID,
            direction: direction,
            resetWithoutEmpty: resetWithoutEmpty,
            processData: function(data) {
                var newData = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, data), {
                    results: []
                });
                if (data.results) {
                    data.results.map(function(item) {
                        var ref, ref1, ref2;
                        var itemData = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, item, item.properties), {
                            courseUID: (ref = item.properties.programme) === null || ref === void 0 ? void 0 : ref.uid,
                            courseSlug: (ref1 = item.properties.programme) === null || ref1 === void 0 ? void 0 : ref1.slug,
                            goal: (ref2 = item.properties.programme) === null || ref2 === void 0 ? void 0 : ref2.goal
                        });
                        delete itemData.properties;
                        delete itemData.programme;
                        newData.results.push({
                            item: itemData
                        });
                        return itemData;
                    });
                }
                return newData;
            }
        });
    };
};
var getBatches = function(goalUID, type, resetWithoutEmpty) {
    return function(next) {
        return {
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .batchTypes.FETCH_BATCHES */ .yt.FETCH_BATCHES,
            endpoint: next,
            method: "get",
            key: "batches_".concat(goalUID, "_").concat(type),
            resetWithoutEmpty: resetWithoutEmpty,
            schema: _schemas__WEBPACK_IMPORTED_MODULE_2__/* .paginatorListSchema */ .EH,
            directPaginatedEntity: true,
            entityType: "batch"
        };
    };
};
var fetchBatches = function(goalUID) {
    var type = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, nextPage = arguments.length > 2 ? arguments[2] : void 0, resetWithoutEmpty = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, forceReset = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    return (0,_utils_paginateAction__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)("v1/batch/lists/filter/?goal_uid=".concat(goalUID, "&type=").concat(type), getBatches(goalUID, type, resetWithoutEmpty), "batches", "batches_".concat(goalUID, "_").concat(type), resetWithoutEmpty, forceReset)(nextPage);
};
var getBatchUpdates = function(batchUID, resetWithoutEmpty) {
    return function(next) {
        return {
            type: batchTypes.FETCH_BATCH_UPDATES,
            endpoint: next,
            method: "get",
            key: batchUID,
            resetWithoutEmpty: resetWithoutEmpty
        };
    };
};
var fetchBatchUpdates = function(batchUID, nextPage) {
    var resetWithoutEmpty = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return paginateAction("v1/channel/batch/".concat(batchUID, "/batch_stories/?limit=7"), getBatchUpdates(batchUID, resetWithoutEmpty), "batchUpdates", batchUID, resetWithoutEmpty)(nextPage);
};
var fetchSimilarBatches = function(batchUID) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .batchTypes.FETCH_SIMILAR_BATCHES */ .yt.FETCH_SIMILAR_BATCHES,
            endpoint: "v1/batch/lists/similar/?batch_uid=".concat(batchUID),
            method: "get",
            batchUID: batchUID,
            schema: _schemas__WEBPACK_IMPORTED_MODULE_2__/* .paginatorListSchema */ .EH,
            directPaginatedEntity: true,
            entityType: "batch",
            processData: function(data) {
                var newData = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, data), {
                    results: []
                });
                if (data.results) {
                    newData.results = data.results.slice(0, 4);
                }
                return newData;
            }
        });
    };
};
var fetchTrialClasses = function(batchUID) {
    return function(dispatch) {
        return dispatch({
            type: batchTypes.FETCH_TRIAL_CLASSES,
            endpoint: "v1/batch/".concat(batchUID, "/trial_classes/"),
            method: "get",
            key: batchUID
        });
    };
};
var fetchBatchFaq = function() {
    var key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "batchesfaq";
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .batchTypes.FETCH_FAQS */ .yt.FETCH_FAQS,
            endpoint: "subscription-faqs/".concat(key, "/"),
            method: "get",
            hostType: _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_0__/* .HOST_TYPE.CMS */ .Bk.CMS
        });
    };
};
var fetchBatchFeedbacks = function(batchUID) {
    return function(dispatch) {
        return dispatch({
            type: batchTypes.FETCH_FEEDBACKS,
            endpoint: "v1/uplus/feedbacks/?limit=4&offset=0&goal_uid=".concat(batchUID),
            method: "get",
            key: batchUID
        });
    };
};
var enrollInTrialClasses = function(batchUID) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .batchTypes.ENROLL_TRIAL_CLASSES */ .yt.ENROLL_TRIAL_CLASSES,
            endpoint: "v1/batch/".concat(batchUID, "/enroll_in_trial_classes/"),
            method: "post"
        });
    };
};
var fetchBatchScheduleWeek = function(batchUID, week) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .batchTypes.FETCH_BATCH_SCHEDULE_WEEKS */ .yt.FETCH_BATCH_SCHEDULE_WEEKS,
            endpoint: "v3/batch/".concat(batchUID, "/schedule/?week=").concat(week),
            method: "get",
            key: week
        });
    };
};
var updateBatchScheduleWeek = function(batchUID, week) {
    return function(dispatch) {
        return dispatch({
            type: _constants__WEBPACK_IMPORTED_MODULE_1__/* .batchTypes.UPDATE_BATCH_SCHEDULE_WEEKS */ .yt.UPDATE_BATCH_SCHEDULE_WEEKS,
            endpoint: "v3/batch/".concat(batchUID, "/schedule/?week=").concat(week),
            method: "get",
            key: week
        });
    };
};


/***/ }),

/***/ 11680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GA": function() { return /* binding */ getUserById; },
/* harmony export */   "jo": function() { return /* binding */ getMe; }
/* harmony export */ });
/* unused harmony exports getProfileInfo, getProfileStats, getLearnerMilestones, getLearnerAchievedMileStones, getCompletedCourses, getFeedRowById, getProfileFeed, getFollowingList, getCourseById, getBatchById, getItemById, getTopologyById, isFollowingEducator */
/* harmony import */ var _constants_empty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59375);

var getMe = function(param) {
    var auth = param.auth;
    return auth.me;
};
var getProfileInfo = function(username) {
    return function(param) {
        var users = param.users;
        return users.data[username];
    };
};
var getProfileStats = function(username) {
    return function(param) {
        var users = param.users;
        return users.profileStats[username] || {};
    };
};
var getLearnerMilestones = function(state, username) {
    return state.users.learnerMilestones[username] || emptyObject;
};
var getLearnerAchievedMileStones = function(state, username) {
    return getLearnerMilestones(state, username).achieved || emptyList;
};
var getCompletedCourses = function(username) {
    return function(param) {
        var paginator = param.paginator;
        return paginator.learnerCourses[username];
    };
};
var getFeedRowById = function(feedrowId) {
    return function(param) {
        var feedrows = param.feedrows;
        return feedrows.data[feedrowId];
    };
};
var _username;
var getProfileFeed = function(username) {
    return function(param) {
        var paginator = param.paginator;
        return (_username = paginator.profileFeed[username]) !== null && _username !== void 0 ? _username : {};
    };
};
var getFollowingList = function(username) {
    return function(param) {
        var paginator = param.paginator;
        return paginator.learnerFollowing[username];
    };
};
var getCourseById = function(courseUID) {
    return function(param) {
        var courses = param.courses;
        return courses.data[courseUID];
    };
};
var getBatchById = function(batchUID) {
    return function(param) {
        var batches = param.batches;
        return batches.data[batchUID];
    };
};
var getUserById = function(username) {
    return function(param) {
        var users = param.users;
        return users.data[username];
    };
};
var getItemById = function(itemUID) {
    return function(param) {
        var items = param.items;
        return items.data[itemUID];
    };
};
var getTopologyById = function(topologyUID) {
    return function(param) {
        var topologies = param.topologies;
        return topologies.data[topologyUID];
    };
};
var isFollowingEducator = function(username) {
    return function(param) {
        var users = param.users;
        var ref;
        return (ref = users.data[username.toLowerCase()]) === null || ref === void 0 ? void 0 : ref.isFollowing;
    };
};


/***/ }),

/***/ 97903:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var getItemFromSessionStorage = function(item) {
    try {
        return sessionStorage.getItem(item);
    } catch (e) {
        return null;
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (getItemFromSessionStorage);


/***/ }),

/***/ 78162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ updateQuery; }
/* harmony export */ });
/* eslint-disable prefer-template */ function updateQuery(uri, key, value) {
    if (uri) {
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf("?") !== -1 ? "&" : "?";
        if (uri.match(re)) return uri.replace(re, "$1" + key + "=" + value + "$2");
        return uri + separator + key + "=" + value;
    }
    return "";
};


/***/ })

}]);